var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sticker",staticClass:"sticker",style:(_vm.style)},[(_vm.dev)?_c('button',{staticStyle:{"position":"absolute","top":"50%","left":"50%","translate":"-50% -50%"},on:{"click":_vm.copy}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62a1e07a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about-me/StickMe.vue
// module id = 366
// module chunks = 1